import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconQuintessRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <rect x="0.600098" width="24" height="24" rx="6" fill="#2C5370" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.45783 8.20508C8.16537 8.53743 7.58043 9.6169 7.58043 11.276C7.58043 13.2534 8.77697 16.79 13.037 17.4604C14.8383 17.5917 16.1044 18.0975 16.514 18.3354C12.976 17.8545 11.075 18.0639 9.38407 18.2502C9.11175 18.2802 8.84488 18.3096 8.5775 18.3354C8.73077 18.2587 9.57129 17.8549 10.7532 17.6163C9.81285 17.3703 8.26564 16.6675 7.46078 15.2243C6.3042 13.1505 6.34409 10.4784 8.45783 8.20508Z"
      fill="white"
    />
    <path
      d="M16.9529 9.40278C15.4533 6.85033 12.8982 6.34516 11.8081 6.41163C13.3635 6.07928 16.8013 6.15638 18.1095 9.1236C19.4176 12.0908 17.8037 14.8002 16.8332 15.7839L16.8408 15.7717C17.1777 15.2246 18.8131 12.569 16.9529 9.40278Z"
      fill="white"
    />
  </svg>
)

export const IconQuintessRectangle = forwardRef(_IconQuintessRectangle)
